'use strict';

import _ from 'lodash';

export default function () {
  return {
    controller: function ($scope, $http, $sce) {
      'ngInject';
    },
    template: '<div class="TransparentArrow"><table><tr><td class="Side"></td><td class="Arrow"><div></div></td><td class="Side"></td></tr></table></div>'
  };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/customElements/downarrow.js